import type {Components} from 'react-markdown';
import type {ChatMessage} from '../hooks/chat/types';
import {MarkdownRenderer, MarkdownTable} from '../markdown-renderer';
import {CopyButton} from './copy-button';
import {
  Message,
  MessageActions,
  MessageContent,
  MessageResponse,
} from './message';

const MARKDOWN_COMPONENTS: Partial<Components> = {table: MarkdownTable};

export interface MarkdownMessageProps {
  message: ChatMessage;
}

export const MarkdownMessage = ({message}: MarkdownMessageProps) => {
  const isFinalized = message.role === 'assistant' && !message.streaming;
  return (
    <Message from={message.role}>
      <MessageContent>
        {message.role === 'error' ? (
          message.content
        ) : (
          <MessageResponse>
            <MarkdownRenderer
              content={message.content ?? ''}
              components={MARKDOWN_COMPONENTS}
              // MarkdownRenderer's own `prose` would reset MessageResponse's size and edge margins.
              className="prose-sm max-w-full [&>*:first-child]:mt-0 [&>*:last-child]:mb-0"
            />
          </MessageResponse>
        )}
      </MessageContent>
      {isFinalized && (
        <MessageActions className="transition-opacity group-hover/assistant:opacity-100 focus-within:opacity-100 [@media(hover:hover)]:opacity-0">
          <CopyButton content={message.content ?? ''} />
        </MessageActions>
      )}
    </Message>
  );
};

export const renderMarkdownMessage = (message: ChatMessage) => (
  <MarkdownMessage message={message} />
);
